import React from 'react'
import BaseTooltip from 'rc-tooltip'

function Tooltip(props) {
  const {
    content,
    target,
    children,
    trigger,
    position,
    ...others
  } = props
  return (
    <BaseTooltip
      prefixCls="rcc-tooltip"
      animation="zoom"
      trigger={trigger}
      overlay={content}
      arrowContent={<div className="popover-arrow-inner" />}
      placement={position}
      {...others}
    >
      {target || children}
    </BaseTooltip>
  )
}

export default Tooltip
